import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export async function downloadPdf(elId, filename, landscape = false) {
  const el = document.getElementById(elId);
  if (!el) return;
  const wasHidden = el.classList.contains("hidden");
  if (wasHidden) {
    el.classList.remove("hidden");
    el.style.position = "absolute"; el.style.left = "-9999px"; el.style.top = "0";
    el.style.width = landscape ? "1400px" : "1000px";
  }
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
  if (wasHidden) { el.classList.add("hidden"); el.style.position = ""; el.style.left = ""; el.style.top = ""; el.style.width = ""; }
  const pdf = new jsPDF({ orientation: landscape ? "landscape" : "portrait", unit: "mm", format: "a4" });
  const pw = pdf.internal.pageSize.getWidth(), ph = pdf.internal.pageSize.getHeight();
  const ih = (canvas.height * pw) / canvas.width;
  const img = canvas.toDataURL("image/jpeg", 0.92);
  if (ih <= ph) { pdf.addImage(img, "JPEG", 0, 0, pw, ih); }
  else {
    let offset = 0;
    while (offset < ih) {
      pdf.addImage(img, "JPEG", 0, -offset, pw, ih);
      offset += ph;
      if (offset < ih) pdf.addPage();
    }
  }
  pdf.save(filename);
}
